import { createContext, useContext, useState, useCallback, useEffect } from "react";

const dict = {
  en: {
    "nav.services": "Services",
    "nav.why": "Why FORM C",
    "nav.contact": "Contact",
    "nav.login": "Client Portal",
    "hero.eyebrow": "CySEC-Regulated · Cyprus & BVI",
    "hero.title": "The regulated partner for international corporate structures.",
    "hero.subtitle": "FORM C forms, administers and safeguards companies for global businesses - with banking, accounting, tax and AML/KYC compliance handled under one roof, by one accountable team.",
    "hero.cta_primary": "Book a consultation",
    "hero.cta_secondary": "Explore services",
    "footer.rights": "© FORM C. All rights reserved.",
    "footer.tag": "Regulated · Auditable · Precise.",
  },
};

const I18nCtx = createContext(null);

export function I18nProvider({ children }) {
  const [lang] = useState("en");
  useEffect(() => { localStorage.setItem("formc_lang", "en"); }, []);
  const t = useCallback((key) => dict[lang]?.[key] ?? key, [lang]);
  return <I18nCtx.Provider value={{ lang, setLang: () => {}, t }}>{children}</I18nCtx.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nCtx);
  if (!ctx) throw new Error("useI18n must be inside I18nProvider");
  return ctx;
}
